module.exports = __webpack_public_path__ + "img/sport.9d9d1abd.png";